import { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { METADATA_QUERY } from '../graphql/queries'
import { COMMON_FETCH_METADATA } from '../redux/action-types'
import { cleanupCommonFetchMetadata } from '../redux/actions'
import { apolloService } from '../services'

import useCleanupRedux from './use-cleanup-redux'

const useMetadataQuery = (lazy = false) => {
  const dispatch = useDispatch()
  useCleanupRedux(cleanupCommonFetchMetadata)

  const { isLoading, error, data } = useSelector(store => store.common.metadata)

  const refetch = useCallback(
    () =>
      apolloService.query({
        query: METADATA_QUERY,
        variables: {},
        dispatch,
        action: COMMON_FETCH_METADATA,
      }),
    [dispatch],
  )

  useEffect(() => {
    if (!lazy) {
      refetch()
    }
  }, [lazy, refetch])

  return {
    isLoading,
    error,
    data,
    refetch,
  }
}

export default useMetadataQuery
